var _style, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.6 30.2",
    style: {
      enableBackground: "new 0 0 28.6 30.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-54.1,19.9c-4.2,0-8.7-0.9-13-2.7c-5.8-2.3-10.7-5.9-13.8-10c-3-4-4-8.1-2.6-11.5c1.7-4.2,6.8-6.7,13.7-6.7 c4.2,0,8.7,0.9,13,2.7c11.9,4.8,19.2,14.5,16.4,21.5C-42.1,17.4-47.2,19.9-54.1,19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69.9-11.5v1h0c4.1,0,8.6,0.9,12.8,2.7C-51.3-5.5-46.5-2-43.4,2c2.9,3.9,3.8,7.8,2.5,11c-1.6,4-6.6,6.4-13.2,6.4 c-4.1,0-8.6-0.9-12.9-2.7C-78.6,12-85.8,2.7-83.1-4.1c1.6-4,6.6-6.4,13.2-6.4L-69.9-11.5 M-69.9-11.5c-6.8,0-12.3,2.5-14.2,7 c-3,7.3,4.5,17.2,16.7,22.1c4.6,1.8,9.1,2.7,13.2,2.7c6.8,0,12.3-2.5,14.2-7c3-7.3-4.5-17.2-16.7-22.1 C-61.2-10.6-65.8-11.5-69.9-11.5L-69.9-11.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-25.5-13.3c-5.8,0-12.7-3-18.5-8c-4.7-4.1-8.2-9-9.9-13.9c-1.6-4.8-1.2-9,1.2-11.7c1.8-2.1,4.6-3.2,8.2-3.2 c5.8,0,12.7,3,18.5,8c4.7,4.1,8.2,9,9.9,13.9c1.6,4.8,1.2,9-1.2,11.7C-19.1-14.5-21.9-13.3-25.5-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44.4-49.7L-44.4-49.7c5.6,0,12.4,2.9,18.1,7.9c4.7,4,8.1,8.9,9.7,13.7c1.5,4.6,1.1,8.6-1.1,11.2c-1.7,2-4.4,3-7.8,3 c-5.6,0-12.4-2.9-18.1-7.9c-9.5-8.2-13.4-19.4-8.6-24.9C-50.5-48.6-47.8-49.7-44.4-49.7 M-44.4-50.7c-3.5,0-6.6,1.1-8.5,3.4 c-5.1,6-1.2,17.8,8.7,26.3c6.1,5.3,13.1,8.1,18.8,8.1c3.5,0,6.6-1.1,8.5-3.4c5.1-6,1.2-17.8-8.7-26.3 C-31.7-47.8-38.7-50.7-44.4-50.7L-44.4-50.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11-32.9c-6.7,0-14.2-6.8-18.5-16.6C-12.5-61.4-11-73.4-4-76.4c1-0.5,2.2-0.7,3.4-0.7c6.7,0,14.2,6.8,18.5,16.6 c5.1,11.8,3.5,23.8-3.4,26.8C13.4-33.2,12.2-32.9,11-32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.6-76.6L-0.6-76.6c6.5,0,13.9,6.7,18,16.3c2.4,5.7,3.4,11.6,2.7,16.6c-0.7,4.8-2.8,8.2-5.9,9.6c-1,0.4-2.1,0.6-3.2,0.6 c-6.5,0-13.9-6.7-18-16.3c-2.4-5.7-3.4-11.6-2.7-16.6c0.7-4.8,2.8-8.2,5.9-9.6C-2.8-76.3-1.7-76.6-0.6-76.6 M-0.6-77.6 c-1.2,0-2.4,0.2-3.6,0.7c-7.2,3.1-8.9,15.4-3.7,27.5C-3.5-39.2,4.3-32.4,11-32.4c1.2,0,2.4-0.2,3.6-0.7c7.2-3.1,8.9-15.4,3.7-27.5 C13.9-70.8,6.1-77.6-0.6-77.6L-0.6-77.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2,47.9c-9.4,0-18-4-23.5-11.1c-5-6.4-7-14.5-5.6-22.9c1.4-8.4,6-16,13-21.4c6.2-4.8,13.7-7.5,21.3-7.5 c9.4,0,18,4,23.5,11.1c10.3,13.2,7,33.1-7.4,44.3C25.3,45.3,17.7,47.9,10.2,47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3-15.4v1h0c9.3,0,17.7,4,23.1,10.9c4.9,6.3,6.9,14.3,5.5,22.5c-1.4,8.3-5.9,15.7-12.8,21.1c-6.1,4.7-13.5,7.3-21,7.3 c-9.3,0-17.7-4-23.1-10.9c-4.9-6.3-6.9-14.3-5.5-22.5c1.4-8.3,5.9-15.7,12.8-21.1c6.1-4.7,13.5-7.3,21-7.3L15.3-15.4 M15.3-15.4 C7.9-15.4,0.2-13-6.3-7.9c-14.6,11.4-17.9,31.5-7.5,45c5.8,7.5,14.7,11.3,23.9,11.3c7.4,0,15.1-2.5,21.6-7.6 c14.6-11.4,17.9-31.5,7.5-45C33.4-11.6,24.5-15.4,15.3-15.4L15.3-15.4z"
  })))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 -3.570013e-03 3.570013e-03 1 -234.1425 14.1994)",
    className: "st0",
    style: {
      fontFamily: "'InkFree'",
      fontSize: "70.4296px"
    }
  }, "PET"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 -3.570013e-03 3.570013e-03 1 68.9825 13.1172)",
    className: "st0",
    style: {
      fontFamily: "'InkFree'",
      fontSize: "70.4296px"
    }
  }, "SHOW"), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6,4.3v21.9c0,2.1,2.3,3.5,4.2,2.4l18.4-10.9c1.8-1.1,1.8-3.7,0-4.8L6.8,1.9C5,0.8,2.6,2.1,2.6,4.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.bafff3210cf55de62db3eb5fb8833fa7.svg";
export { ForwardRef as ReactComponent };